import React, { memo } from 'react';

const UsersIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M16 16c4.42 0 8-3.58 8-8s-3.58-8-8-8c-4.42 0-8 3.58-8 8s3.58 8 8 8zM16 20c-5.34 0-15.999 2.68-15.999 8v4h31.999v-4c0-5.32-10.66-8-15.999-8z"
        />
    </svg>
);

export default memo(UsersIcon);
